export async function downloadVaultRom(appUrlFn, vaultId) {
  const r = await fetch(appUrlFn(`api/vault/${vaultId}/download-rom`), { method: 'POST' });
  const data = await r.json().catch(() => ({}));
  if (!r.ok) throw new Error(data.error || `HTTP ${r.status}`);
  return data;
}
